export default {"src":"/_next/static/media/greengo.1567e664.svg","height":84,"width":75,"blurWidth":0,"blurHeight":0};